import { render, staticRenderFns } from "./RegisterPage.vue?vue&type=template&id=dc993bae&scoped=true"
import script from "./RegisterPage.vue?vue&type=script&lang=js"
export * from "./RegisterPage.vue?vue&type=script&lang=js"
import style0 from "./RegisterPage.vue?vue&type=style&index=0&id=dc993bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc993bae",
  null
  
)

export default component.exports